import { ROUTES } from '@/types/common';
import { useRef, useState } from 'react';
import useCustomRouter from '../useCustomRouter';

export interface MedicineDictionaryViewModel {
  queries: {
    keyword: string;
    page: string;
  };
  keyword: string;
  searchInputRef: React.RefObject<HTMLInputElement>;
  handleSubmit: () => void;
  handleResetSearchKeyword: () => void;
  handleBackButtonClick: () => void;
  handleChangeSearchKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const useMedicineDictionaryViewModel = (): MedicineDictionaryViewModel => {
  const { router } = useCustomRouter();
  const queries = router.isReady ? (router.query as { keyword: string; page: string }) : { keyword: '', page: '1' };

  const searchInputRef = useRef<HTMLInputElement>(null);
  const [keyword, setKeyword] = useState(queries.keyword || '');

  const handleSubmit = () => {
    const searchKeyword = searchInputRef.current?.value || '';
    if (searchKeyword) {
      router.push({
        pathname: ROUTES.MEDICINE_DICTIONARY.SEARCH.path,
        query: { keyword: searchKeyword },
      });
    }
  };

  const handleResetSearchKeyword = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
    router.push({
      pathname: ROUTES.MEDICINE_DICTIONARY.HOME.path,
      query: {},
    });
  };

  const handleBackButtonClick = () => {
    router.back();
  };

  const handleChangeSearchKeyword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(e.target.value);
  };

  return {
    queries,
    keyword,
    searchInputRef,
    handleSubmit,
    handleResetSearchKeyword,
    handleBackButtonClick,
    handleChangeSearchKeyword,
  };
};

export default useMedicineDictionaryViewModel;
